import MACurrentMarketPage from './MACurrentMarketPage'
// Uncomment the below to migrate to stateful component
// import MACurrentMarketPageContainer from './MACurrentMarketPageContainer'

export { MACurrentMarketPage }
export default MACurrentMarketPage
// Uncomment the below to migrate to stateful component
// export { MACurrentMarketPageContainer }
// export default { MACurrentMarketPageContainer }
